import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import { getIconColour } from '../../../../helpers/app';
import CrmSection from './CrmSection';
import SettingsIcon from '../../../../assets/icons/settings';
import { StyledGrid, AppInfo } from './common';
import { generalSettingsState } from './helper';
import { ApplicationManagerInterface } from '../../../../interfaces/application';

type PropsType = {
  project: ApplicationManagerInterface;
};

const CrmGeneralSettings: React.FC<PropsType> = ({ project }) => {
  const theme = useTheme();
  const { application, organisation } = project;
  const type = generalSettingsState(application);

  return (
    <CrmSection
      icon={<SettingsIcon stroke={getIconColour(type, theme)} />}
      title="General Settings"
      description="Project Name, ID, namespace, and team information. "
      type={type}
    >
      <StyledGrid>
        <AppInfo label="Company Name" value={organisation.name} />
        <AppInfo label="Country" value={organisation.country} />

        <AppInfo label="Application Name" value={application.info.name} />
        <AppInfo label="Application Website" value={application.info.website} />

        <AppInfo label="Application ID" value={application.info.applicationId} />
        <AppInfo label="Application Namespace" value={application.setup.namespace} />
      </StyledGrid>
    </CrmSection>
  );
};

export default CrmGeneralSettings;
